import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_HAS_OFFER_BAR } from "utils/action-types";
import RichText from "components/rich-text";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { closedOfferBar } from "utils/constants";
import Button from "components/button";
import { getRgba } from "helpers/get-rgba";
import clsx from "clsx/lite";

const OfferBar = ({ data, generalData }) => {
	const { authenticated } = useSelector(state => state.account.profile);
	const { stickyATCShown } = useSelector(state => state.global);
	const [isClosed, setIsClosed] = useState(true);
	const dispatch = useDispatch();

	const {
		settings: offerSettings = {},
		authSettings: offerAuthSettings = {}
	} = data || {};

	const {
		settings: generalSettings = {},
		authSettings: generalAuthSettings = {}
	} = generalData || {};

	const offerBarData = authenticated
		? (offerAuthSettings?.enabled ? offerAuthSettings : generalAuthSettings)
		: (offerSettings?.enabled ? offerSettings : generalSettings);

	const { text, txtColor, bgColor, closeColor, button } = offerBarData;


	useEffect(() => {
		const closed = window.sessionStorage.getItem(closedOfferBar);
		setIsClosed(closed);
		dispatch({ type: SET_HAS_OFFER_BAR, payload: !closed });
	}, []);

	useEffect(() => {
		if (stickyATCShown) 
			setTimeout(() => setIsClosed(true), 300);
	}, [stickyATCShown]);

	const handleClose = () => {
		setIsClosed(true);
		sessionStorage.setItem(closedOfferBar, true);
	};

	if (!text?.length > 0 || isClosed) return null;

	return (
		<div style={{ backgroundColor: getRgba(bgColor), color: getRgba(txtColor) }}
			className={clsx("w-full text-center px-2 md:px-5 flex items-center justify-center transition-opacity duration-300 py-2.5 tracking-wider",
				stickyATCShown ? "opacity-0" : "opacity-100")}
		>
			<div className="flex flex-wrap w-full justify-center items-center gap-x-5 gap-y-2">
				<RichText value={text} isFullWidth />
				<Button data={button} className="!px-4 py-2.5" />
			</div>
			<Close onClick={handleClose}
				className="w-5 h-5 cursor-pointer"
				stroke={getRgba(closeColor)}
				fill={getRgba(closeColor)} />
		</div>
	);
};

export default OfferBar;
